import React, { useEffect, useState } from 'react';
import { useParams, Link, useLocation } from 'react-router-dom';
import {
  useGetPollQuery,
  useVoteInPollMutation,
} from '../../../../redux/services/polls.jsx';
import { ContentBlock, Spinner } from '../../../common/index.jsx';
import PollNotActive from './SubPages/PollNotActive.jsx';
import PollDynamicPage from './SubPages/PollDynamicPage.jsx';
import { useSelector } from 'react-redux';
import PollAnswered from './SubPages/PollAnswered.jsx';
import { useToastMessages } from '../../../../hooks/useToastMessages.jsx';
import PollResults from './SubPages/PollResults.jsx';
import { useTranslation } from 'react-i18next';
import {
  ROLE_STUDENT,
  ROLE_TEACHER,
} from '../../../../utils/constants/roles.js';

const PollsVotePage = () => {
  const { slug } = useParams();
  const location = useLocation();
  const { isLoggedIn } = useSelector((state) => ({
    isLoggedIn: state.auth.isLoggedIn,
  }));
  const { t } = useTranslation();

  const { saveSuccess: showSaveSuccess } = useToastMessages();

  const { data, isLoading, refetch } = useGetPollQuery(slug);
  // true right after voting on this page, then only the thanks is shown instead of the "already voted" notice
  const [hasJustVoted, setHasJustVoted] = useState(false);

  const user = useSelector((state) => state.auth.user);

  const [savePoll, { isSuccess: saveSuccess, isLoading: isSaving }] =
    useVoteInPollMutation(slug);

  const onSubmit = (values) => {
    const remappedArray = Object.keys(values).map((key) => ({
      question_id: parseInt(key),
      response_id: values[key].response_id,
    }));
    const wrapped = {
      body: remappedArray,
      id: slug,
    };
    if (isSaving) return;
    savePoll({ body: wrapped })
      .unwrap()
      // the error toast is shown by the global API interceptor;
      // e.g. the vote was already recorded in another tab, show the current state
      .catch(() => refetch());
  };

  useEffect(() => {
    if (saveSuccess) {
      setHasJustVoted(true);
      showSaveSuccess();
      refetch();
    }
  }, [saveSuccess]);

  const checkUserCanVoteInPoll = (pollUserType, userRole) => {
    var retrunValue = false;
    userRole?.forEach((role) => {
      pollUserType.forEach((pollRole) => {
        if (pollRole === 1) {
          retrunValue = retrunValue || role.name === ROLE_STUDENT;
        } else {
          retrunValue = retrunValue || role.name === ROLE_TEACHER;
        }
      });
    });
    return retrunValue;
  };

  const render = () => {
    if (data === undefined || data.success === false) {
      return <PollNotActive />;
    } else {
      if (
        checkUserCanVoteInPoll(data.polls_users_type, user?.roles) === false
      ) {
        return (
          <div className="news-detail-page-container add-icons-to-file-anchors">
            <ContentBlock
              contentVisible
              blockWrapper="block-wrapper"
              contentWrapper="content-wrapper"
              shadow
              title={data.name}
            >
              <>
                {t('Na vyplnenie ankety ')}
                <Link
                  to="/login"
                  state={{ from: `${location.pathname}${location.search}` }}
                >
                  {t('sa musíte prihlásiť')}
                </Link>
                {t(' a je dostupná len pre študentov.')}
              </>
            </ContentBlock>
          </div>
        );
      } else if (data.show_results === 1 && data.active === 0) {
        return <PollResults data={data} pollText={t('Výsledky ankety')} />;
      } else if (data.active === 0) {
        return <PollNotActive data={data} />;
      } else if (data.active === 1 && isLoggedIn === false) {
        return (
          <div className="news-detail-page-container add-icons-to-file-anchors">
            <ContentBlock
              contentVisible
              blockWrapper="block-wrapper"
              contentWrapper="content-wrapper"
              shadow
              title={data.name}
            >
              <>
                {t('Do ankety sa budete môcť zapojiť, keď sa ')}
                <Link
                  to="/login"
                  state={{ from: `${location.pathname}${location.search}` }}
                >
                  {t('prihlásite')}
                </Link>
                {t('.')}
              </>
            </ContentBlock>
          </div>
        );
      } else if (
        data.active === 1 &&
        data.answered.length > 0 &&
        data.show_results === 1
      ) {
        return (
          <PollResults
            data={data}
            pollText={
              hasJustVoted
                ? t('Ďakujeme za vašu účasť v ankete.')
                : t('V tejto ankete ste už hlasovali. Ďakujeme za vašu účasť.')
            }
          />
        );
      } else if (data.active === 1 && data.answered.length > 0) {
        return <PollAnswered data={data} hasJustVoted={hasJustVoted} />;
      } else {
        return <PollDynamicPage data={data} onSubmit={onSubmit} />;
      }
    }
  };

  return isLoading ? <Spinner /> : <>{render()}</>;
};

export default PollsVotePage;
